namespace Matrix.Data {
    export interface DataDictionaryForm {
        TableSchema: Serenity.StringEditor;
        MxTableName: Serenity.StringEditor;
        AliasView: Serenity.StringEditor;
        ColumnName: Serenity.StringEditor;
        Alias: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        IsSystemColumn: Serenity.StringEditor;
        OrdinalPosition: Serenity.IntegerEditor;
        ColumnDefault: Serenity.StringEditor;
        IsNullable: Serenity.StringEditor;
        DataType: Serenity.StringEditor;
        CharacterMaximumLength: Serenity.IntegerEditor;
        CharacterOctetLength: Serenity.IntegerEditor;
        NumericPrecision: Serenity.IntegerEditor;
        NumericPrecisionRadix: Serenity.IntegerEditor;
        NumericScale: Serenity.IntegerEditor;
        DatetimePrecision: Serenity.IntegerEditor;
        CharacterSetCatalog: Serenity.StringEditor;
        CharacterSetSchema: Serenity.StringEditor;
        CharacterSetName: Serenity.StringEditor;
        CollationCatalog: Serenity.StringEditor;
        CollationSchema: Serenity.StringEditor;
        CollationName: Serenity.StringEditor;
        DomainCatalog: Serenity.StringEditor;
        DomainSchema: Serenity.StringEditor;
        DomainName: Serenity.StringEditor;
    }

    export class DataDictionaryForm extends Serenity.PrefixedContext {
        static formKey = 'Data.DataDictionary';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DataDictionaryForm.init)  {
                DataDictionaryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(DataDictionaryForm, [
                    'TableSchema', w0,
                    'MxTableName', w0,
                    'AliasView', w0,
                    'ColumnName', w0,
                    'Alias', w0,
                    'Description', w0,
                    'IsSystemColumn', w0,
                    'OrdinalPosition', w1,
                    'ColumnDefault', w0,
                    'IsNullable', w0,
                    'DataType', w0,
                    'CharacterMaximumLength', w1,
                    'CharacterOctetLength', w1,
                    'NumericPrecision', w1,
                    'NumericPrecisionRadix', w1,
                    'NumericScale', w1,
                    'DatetimePrecision', w1,
                    'CharacterSetCatalog', w0,
                    'CharacterSetSchema', w0,
                    'CharacterSetName', w0,
                    'CollationCatalog', w0,
                    'CollationSchema', w0,
                    'CollationName', w0,
                    'DomainCatalog', w0,
                    'DomainSchema', w0,
                    'DomainName', w0
                ]);
            }
        }
    }
}
